import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function ActividadesPreview() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const images = [{
    src: 'https://cdn.magicpatterns.com/uploads/rxq44ggswLXExnYW9QBgzA/Captura_de_pantalla_2025-12-15_234410.png',
    alt: 'Actividad 41 – Verdadero o falso: Características de un texto narrativo'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ngRbptjg8JMH69MPsWydzo/Captura_de_pantalla_2025-12-15_234457.png',
    alt: 'Actividad 17 – Completar espacios: Conectores argumentativos'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/k4TK9y62W3MZnRWCRK5BXT/Captura_de_pantalla_2025-12-15_234149.png',
    alt: 'Actividad 19 – Análisis de un texto expositivo'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/2o6WWW2nzqY8sMf955TLZH/Captura_de_pantalla_2025-12-15_234300.png',
    alt: 'Actividad 33 – Conectores argumentativos'
  }];
  const goToPrev = () => {
    setCurrentIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
  };
  const goToNext = () => {
    setCurrentIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
  };
  return <section className="py-5 sm:py-14 bg-transparent relative border-t border-gray-800" data-id="element-18">
      <div className="max-w-3xl mx-auto px-3 sm:px-6" data-id="element-19">
        <div className="text-center mb-4 sm:mb-8" data-id="element-20">
          <h2 className="text-xl sm:text-4xl md:text-5xl font-bold text-white mb-2 sm:mb-3" data-id="element-21">
            Estas son algunas de las actividades que encontrarás en el{' '}
            <span className="text-[#D4A843]" data-id="element-22">
              Kit Completo de Lengua y Literatura
            </span>
          </h2>
          <p className="text-sm sm:text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-23">
            Material listo para aplicar en el aula, con consignas claras y
            respuestas docentes incluidas.
          </p>
        </div>
        <div className="relative" data-id="element-24">
          <div className="rounded-xl overflow-hidden shadow-xl border border-[#D4A843]/30 cursor-pointer" onClick={scrollToOffer} data-id="element-25">
            <img src={images[currentIndex].src} alt={images[currentIndex].alt} className="w-full h-auto transition-opacity duration-300" data-id="element-26" />
          </div>
          <button onClick={goToPrev} className="absolute left-2 sm:left-3 top-1/2 -translate-y-1/2 bg-black/60 hover:bg-[#D4A843] text-white rounded-full p-1.5 sm:p-2 shadow-lg transition-colors z-10" aria-label="Anterior" data-id="element-27">
            <ChevronLeftIcon className="h-5 w-5 sm:h-6 sm:w-6" data-id="element-28" />
          </button>
          <button onClick={goToNext} className="absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 bg-black/60 hover:bg-[#D4A843] text-white rounded-full p-1.5 sm:p-2 shadow-lg transition-colors z-10" aria-label="Siguiente" data-id="element-29">
            <ChevronRightIcon className="h-5 w-5 sm:h-6 sm:w-6" data-id="element-30" />
          </button>
          <div className="flex justify-center gap-2 mt-3 sm:mt-4" data-id="element-31">
            {images.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-all ${idx === currentIndex ? 'bg-[#D4A843] scale-110 shadow-[0_0_10px_rgba(212,168,67,0.5)]' : 'bg-gray-600 hover:bg-gray-500'}`} aria-label={`Ir a actividad ${idx + 1}`} data-id="element-32" />)}
          </div>
        </div>
      </div>
    </section>;
}